








































































































import { Component, Vue, Prop } from "vue-property-decorator";   
import axios from 'axios';
import { General } from '@/services/General';
import { DropDownItem } from "@/services/DropDownItem";
import { MaterialLabelEntity, Oem } from "@/entity/MaterialLabel/MaterialLabelEntity";
import { Country } from "@/entity/Country";
import { Material } from "@/entity/Material";
import { i18n } from "@/i18n/i18n-setup";

@Component({
    components: {
        
    }
})
export default class LabelDetail extends Vue {
    isSaveClicked: boolean = false;      
    dropDownOem: any = new Array();
    dropDownRegion: any = new Array();
    uploading: boolean = false;    
    uploadPercFront: number = 0;
    uploadPercBack: number = 0;
    chunkSize: number = 300;    
    fileName: string = '';
    loading: boolean = false;
    entity: MaterialLabelEntity = null;
    idMaterial: string = null;
    idSessionFront: string = null;
    idSessionBack: string = null;
    materialCodeError: boolean = false;
    regionsError: boolean = false;
    fileErrorFront: boolean = false;
    fileErrorBack: boolean = false;



    @Prop({
        required: false
    })
    idMaterialLabel: string;
    @Prop({
        required: false
    })
    dropDownOemProp: Array<any>;
    @Prop({
        required: false
    })
    dropDownRegionProp: Array<any>;

    returnState(condiction: boolean, clickButton: boolean): boolean {
        if (clickButton)
            return condiction
        else return null;
    }
    showUpdateDate(){
        return General.formatDateTime(this.entity.updateDate);
    }

    getFileFrontUrl(id: string) {
        return General.GetApiUrl("/api/MaterialLabel/download/front/" + id);
    }
    getFileBackUrl(id: string) {
        return General.GetApiUrl("/api/MaterialLabel/download/back/" + id);
    }
    getPreviewFrontUrl(id: string) {
        return General.GetApiUrl("/api/MaterialLabel/download/front/preview/" + id);
    }
    getPreviewBackUrl(id: string) {
        return General.GetApiUrl("/api/MaterialLabel/download/back/preview/" + id);
    }
    resetFileFront(){        
        this.entity.idSessionFront = null;
    }
    resetFileBack(){        
        this.entity.idSessionBack = null;
    }
    getFileName(fileName: string) {            
            this.fileName = fileName;
        }
    showSuccessAlertFront(sessionId: any) {                
        this.entity.idSessionFront = sessionId;
        this.entity.previewFrontExists = false;
        this.uploadPercFront = 100;
        this.$forceUpdate();
        
    }
    showSuccessAlertBack(sessionId: any) {                
        this.entity.idSessionBack = sessionId;
        this.entity.previewBackExists = false;
        this.uploadPercBack = 100;
        this.$forceUpdate();
        
    }
    updateProgressFront(e: any) {
            this.uploadPercFront = e;
        }
    updateProgressBack(e: any) {
            this.uploadPercBack = e;
        }
    getResultValue(result) {
        return result.materialCode + ' - ' + result.description;
    }
    materialSelected(item: any) {
        if (item!=null){
            
            this.entity.material.idMaterial = item.idMaterial;               
            this.$forceUpdate();
        }
    }

    async mounted() {
        this.loading = true;

        if(!this.dropDownOemProp) 
            this.dropDownOem = await this.getDropdownOem();
        else
            this.dropDownOem = this.dropDownOemProp;

        if(!this.dropDownRegionProp)
            this.dropDownRegion = await this.getDropdownCountries();
        else
            this.dropDownRegion = this.dropDownRegionProp;

        this.isSaveClicked = false;
        if (this.idMaterialLabel!=null){
            try{
                this.entity = (await axios.get<MaterialLabelEntity>(
                    General.GetApiUrl('/api/MaterialLabel')+'/'+this.idMaterialLabel,{ withCredentials: true})).data;
                
            }catch(error){
                General.HandleError(error, this);
            }
        }else{
            this.entity = new MaterialLabelEntity();
            this.entity.material = new Material();
            this.entity.oem = new Oem();
            this.entity.region = new Country();
            this.entity.idSessionFront = null;
            this.entity.idSessionBack = null;            
            
        }
        this.loading = false;
    } 
    async getDropdownOem(): Promise<Array<any>> {
        try{
            let item: DropDownItem = new DropDownItem();
            let itemList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Oem'),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                response.data.forEach( element => {
                    item = new DropDownItem();
                    item.idDropDownItem = element.id;
                    item.itemText = element.name;

                    itemList.push(item);
                });
                return General.SetOptionsDropDown(itemList);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }
    async getDropdownCountries(): Promise<Array<any>> {
        try{
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/MaterialLabel/GetCountries'),{
                responseType: "json",
                withCredentials: true
               
            });
            if(response.data) {
                response.data.forEach( element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }
    async deleteAction(){
        General.confirm(
            i18n.t('GENERIC.CONFIRM_MESSAGE') as string,
            this,
            async () => {
                this.loading = true;
                try{
                    await axios.delete(General.GetApiUrl('/api/MaterialLabel/'+this.entity.id));
                    this.$emit('saved');
                    General.showAlertSuccess("Deletion completed", this);
                }
                catch(error){
                    General.HandleError(error, this);
                }
                finally{
                    this.loading = false;
                }
            });
    }
    async save(){
        
        General.confirm(
            i18n.t('GENERIC.CONFIRM_MESSAGE') as string,
            this,
            async () => {
               
                if (this.entity.material.idMaterial)                    
                    this.materialCodeError = false;                    
                else
                    this.materialCodeError = true;
                
                
                if (this.entity.region.idCountry)                    
                    this.regionsError = false;                    
                else
                    this.regionsError = true;

                  
                if (this.entity.idSessionFront!=null || this.entity.id)
                    this.fileErrorFront = false;
                else
                    this.fileErrorFront = true;
                if (this.entity.idSessionBack!=null || this.entity.id)
                    this.fileErrorBack = false;
                else
                    this.fileErrorBack = true;

                this.isSaveClicked = true;
                this.loading = true;
                try{     
                    if (this.materialCodeError==false && this.regionsError==false && this.fileErrorFront==false){                        
                        if (this.entity.id == null) {
                            await axios.post(General.GetApiUrl('/api/MaterialLabel')
                                                        ,this.entity
                                                        ,{ withCredentials: true });
                        } else {
                            await axios.put(General.GetApiUrl('/api/MaterialLabel')
                                                        ,this.entity
                                                        ,{ withCredentials: true })
                        }
                            
                        this.$emit('saved');
                        General.showAlertSuccess("Saved!", this);       
                    }
                }
                catch(error){
                    
                    if (error.response.status != 409)                    
                        General.HandleError(error, this);
                    else
                        General.confirm( 
                            i18n.t('GENERIC.CONFIRM_MATERIALLABEL_REPLACE') as string,
                            this,
                            async () => {                                
                                this.entity.id = error.response.data;
                                try{
                                    await axios.put(General.GetApiUrl('/api/MaterialLabel')
                                                        ,this.entity                                                        
                                                        ,{ withCredentials: true })
                                    this.$emit('saved');     
                                    General.showAlertSuccess("Saved!", this);
                                    
                                }
                                catch(error){
                                    General.HandleError(error, this);
                                }
                            });
                }
                finally{
                    this.loading = false;
                }
            }
        );
    }
}
